import React from 'react';

const viViewCard = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="currentColor" d="M11 13v10H1V13h10zm12 0v10H13V13h10zm0-12v10H13V1h10zM11 1v10H1V1h10z" />
    </g>
  </svg>
);

export default viViewCard;
